module.exports = __webpack_public_path__ + "static/california_350-031a928b05d62ff42914aba8e34d6fa6.jpg";